module.exports = __webpack_public_path__ + "static/media/standard-tagline-color.c9cdf717.svg";